enum DialogReasons {
  EscapeKeyDown = 'escapeKeyDown',
  BackdropClick = 'backdropClick'
};

export default DialogReasons;
